import { Box, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import i18next from "i18next";
import { colors } from "../../theme/colors";

const CustomLanguageSelector = () => {
  const [currentLangCode, setCurrentLangCode] = useState(localStorage.getItem("i18nextLng")?.toUpperCase());
  const handleChangeLang = (lang) => {
    if (lang === "FR") {
      i18next.changeLanguage("fr");
      setCurrentLangCode("FR");
    }
    if (lang === "EN") {
      i18next.changeLanguage("en");
      setCurrentLangCode("EN");
    }
    window.location.reload();
  };
  return (
    <Box position="relative" margin="0px">
      <Box display="flex" gap="6px">
        <Box>
          <IconButton onClick={() => handleChangeLang("FR")} sx={currentLangCode === "FR" ? { backgroundColor: colors.main, color: "white" } : { backgroundColor: "lightgray", color: "black" }}>
            <Typography sx={{ fontWeight: "600" }}>FR</Typography>
          </IconButton>
        </Box>
        <Box border="1px solid black" margin="2px 0px"></Box>
        <Box>
          <IconButton onClick={() => handleChangeLang("EN")} sx={currentLangCode === "EN" ? { backgroundColor: colors.main, color: "white" } : { backgroundColor: "lightgray", color: "black" }}>
            <Typography sx={{ fontWeight: "600" }}>EN</Typography>
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};
export default CustomLanguageSelector;
